<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <button class="dialog-close-btn" (click)="close()" align="right">
    <mat-icon>close</mat-icon>
  </button>
</mat-dialog-actions>
<div class="add-cart-container">
  <p mat-dialog-title>{{'add_cart.title.select_units_to_add' | translate}}:</p>

  <mat-dialog-content>
    <p class="licence-title">{{product.name}}</p>
    <app-add-cart [product]="product" [dialogRef]="dialogRef"></app-add-cart>
  </mat-dialog-content>
</div>
